import { createStore } from 'satcheljs';
import { DesktopNotificationSettingsSchema } from './schema';
import { NotificationSettingValue } from '../utils/Constants';
import { ObservableMap } from 'mobx';

export const getNotificationSettingsStore = createStore<DesktopNotificationSettingsSchema>(
    'desktopNotificationSettingsStore',
    {
        settings: new ObservableMap<string, NotificationSettingValue>(),
        desktopNotificationSettingsDirty: false,
        backupSettings: new ObservableMap<string, NotificationSettingValue>(),
    }
);
